module.exports = __webpack_public_path__ + "static/media/Oracle_logo.7058eee9.svg";